import { FormControl, TextField, Typography } from '@mui/material'
import React from 'react'

const CustomTextArea = ({ label, value, onChange, rows }) => {
    return (
        <div>
            <Typography sx={{
                fontFamily: 'Times New Roman',
                fontWeight: '400',
                fontSize: '18px',
                lineHeight: '20.7px',
                color: '#3D3D3D',
                paddingBottom: '10px'
            }}>{label}</Typography>
            <FormControl fullWidth variant="outlined">
                <TextField
                    id="custom-textarea"
                    value={value}
                    onChange={onChange}
                    multiline // Enable multiline mode
                    rows={rows} // Number of rows
                    variant="outlined"
                    sx={{
                        width: '100%', // Full width
                        fontFamily: 'Times New Roman',
                        fontSize: '17px',
                        borderColor: '#D0D0D0',
                        '& .MuiOutlinedInput-root': {
                            borderColor: '#D0D0D0',
                            '& fieldset': {
                                borderColor: '#D0D0D0',
                            },
                            '&:hover fieldset': {
                                borderColor: '#D0D0D0',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#D0D0D0',
                            },
                        },
                    }}
                />
            </FormControl>
        </div>
    )
}

export default CustomTextArea